import { YaysonPresenter } from './../../../model-repository'

import { DisplayTypePresenter } from '../'

const TYPE = 'question-types'

export class QuestionTypePresenter extends YaysonPresenter {

  public type: string = TYPE

  public attributes(json) {
    return {
      name: json['name']
    }
  }

  public relationships() {
    return {
      'display-type': DisplayTypePresenter
    }
  }
}

QuestionTypePresenter.prototype.type = TYPE



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/data/presenters/question-type/question-type.presenter.ts